import { guid } from '@/mixins/guid';
import _ from 'lodash';
import { form as frm } from './field-types';

export default function form() {
  const name = _.cloneDeep(frm.fields.find(f => f.type === 'text'));
  const message = _.cloneDeep(frm.fields.find(f => f.type === 'textarea'));
  return {
    _id: false,
    type: 'droplet.form',
    fields: [
      {
        ...name,
        _id: guid.methods.guid(),
        label: 'Name',
      },
      {
        ...message,
        _id: guid.methods.guid(),
        label: 'Message',
      },
    ],
    successMessage: 'Message Successfully Sent! We will be in touch.',
    mediaQueries: [
      {
        selector:
          '.drzForm-fieldContainer input::-webkit-input-placeholder, textarea.drzForm-textarea::-webkit-input-placeholder',
        properties: [
          {
            property: 'color',
            desktop: 'default',
            tablet: 'default',
            mobile: 'default',
          },
        ],
      },
      {
        selector:
          '.drzForm-fieldContainer input::-moz-placeholder, textarea.drzForm-textarea::-moz-placeholder',
        properties: [
          {
            property: 'color',
            desktop: 'default',
            tablet: 'default',
            mobile: 'default',
          },
        ],
      },
      {
        selector:
          '.drzForm-fieldContainer input:-ms-input-placeholder, textarea.drzForm-textarea:-ms-input-placeholder',
        properties: [
          {
            property: 'color',
            desktop: 'default',
            tablet: 'default',
            mobile: 'default',
          },
        ],
      },
      {
        selector:
          '.drzForm-fieldContainer input, textarea.drzForm-textarea, select.drzForm-select',
        properties: [
          {
            property: 'background-color',
            desktop: 'default',
            tablet: 'default',
            mobile: 'default',
          },
          {
            property: 'color',
            desktop: 'default',
            tablet: 'default',
            mobile: 'default',
          },
        ],
      },
      {
        selector:
          '.drzForm-fieldContainer input:not([type="checkbox"]):not([type=radio]):focus, textarea.drzForm-textarea:focus, select.drzForm-select:focus',
        properties: [
          {
            property: 'background-color',
            desktop: 'default',
            tablet: 'default',
            mobile: 'default',
          },
          {
            property: 'border',
            desktop: 'default',
            tablet: 'default',
            mobile: 'default',
          },
        ],
      },
      {
        selector: '.drzForm-checkbox:checked, .drzForm-radio:checked',
        properties: [
          {
            property: 'background-color',
            desktop: 'rgba(0, 0, 0, 0.5)',
            tablet: 'default',
            mobile: 'default',
          },
        ],
      },
      {
        selector: '.drzForm-header, .drzForm-fieldLabel, .drzForm-checkLabel',
        properties: [
          {
            property: 'color',
            desktop: 'default',
            tablet: 'default',
            mobile: 'default',
          },
        ],
      },
      {
        selector: '.drzBtn-link',
        properties: [
          {
            property: 'background-color',
            desktop: 'default',
            tablet: 'default',
            mobile: 'default',
          },
        ],
      },
      {
        selector: '.drzBtn',
        properties: [
          {
            property: 'color',
            desktop: 'default',
            tablet: 'default',
            mobile: 'default',
          },
        ],
      },
      {
        global: true,
        selector: '.drzForm',
        properties: [
          {
            property: 'top',
            unit: 'px',
            desktop: '0',
            tablet: '0',
            mobile: '0',
          },
          {
            property: 'left',
            unit: 'px',
            desktop: '0',
            tablet: '0',
            mobile: '0',
          },
        ],
      },
    ],
    sendBtnTxt: 'Submit',
    resetBtnTxt: 'Reset',
    sendEmail: false,
    webhooks: [],
    sendEmailAddress: null,
    pageCSS: '',
    activeField: null,
    activeFieldIndex: null,
    activeFieldId: null,
    editingField: false,
    addingNewField: true,
    bounceDroplet: false,
    isShared: false,
    templateRegion: false,
  };
}



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/form/droplet.schema.js